import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "We All Scream for Ice Cream",
  date: new Date(2024, 2, 10),
  img: "/img/sunrise.jpeg",
  video: "/videos/sunrise.mp4",
  tracks: [
    {
      title: "River Of Instruction Booklets",
      src: "/songs/2024-03-10/river_of_instruction_booklets.mp3",
      duration: 614.544,
    },
    {
      title: "Save It For Another Day",
      src: "/songs/2024-03-10/save_it_for_another_day.mp3",
      duration: 830.712,
    },
    {
      title: "Call Your Mother",
      src: "/songs/2024-03-10/call_your_mother.mp3",
      duration: 975.552,
    },
    {
      title: "Hit The Road",
      src: "/songs/2024-03-10/hit_the_road.mp3",
      duration: 744.6,
    },
    {
      title: "Star Hopping",
      src: "/songs/2024-03-10/star_hopping.mp3",
      duration: 355.2,
    },
    {
      title: "Daylight Savings",
      src: "/songs/2024-03-10/daylight_savings.mp3",
      duration: 532.08,
    },
    {
      title: "War & Poverty",
      src: "/songs/2024-03-10/war_and_poverty.mp3",
      duration: 537.912,
    },
    {
      title: "All Is Not Okay",
      src: "/songs/2024-03-10/all_is_not_okay.mp3",
      duration: 813.144,
    },
    {
      title: "Level Up",
      src: "/songs/2024-03-10/level_up.mp3",
      duration: 1555.536,
    },
    {
      title: "A Long Long Time Ago",
      src: "/songs/2024-03-10/a_long_long_time_ago.mp3",
      duration: 990.96,
    },
    {
      title: "Call Your Father",
      src: "/songs/2024-03-10/call_your_father.mp3",
      duration: 546.96,
    },
    {
      title: "Gyroscope",
      src: "/songs/2024-03-10/gyroscope.mp3",
      duration: 480.456,
    },
    {
      title: 'Rodger That: "Part 5"',
      src: "/songs/2024-03-10/rodger_that_part_five.mp3",
      duration: 690.048,
    },
    {
      title: "Stardusted",
      src: "/songs/2024-03-10/stardusted.mp3",
      duration: 1354.008,
    },
    {
      title: "Get It Off Your Chest",
      src: "/songs/2024-03-10/get_it_off_your_chest.mp3",
      duration: 1545,
    },
    {
      title: "Pillow Fight",
      src: "/songs/2024-03-10/pillow_fight.mp3",
      duration: 744.504,
    },
  ],
};
export default album;
